import { assert } from '@ember/debug';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

export interface WrFormRadioControlComponentSignature {
  Element: HTMLInputElement;
  Args: {
    id?: string;
    styles?: string;
    onChange?: (value: string, e: Event | InputEvent) => void;
    isChecked?: boolean;
    value: string | number;
    isReadOnly?: boolean;
  };
}

export default class WrFormRadioControlComponent extends Component<WrFormRadioControlComponentSignature> {
  handleInput = (e: Event | InputEvent): void => {
    assert('Expected HTMLInputElement', e.target instanceof HTMLInputElement);
    this.args.onChange?.(e.target.value, e);
  };

  get styles() {
    return [
      this.args.styles,
      'form-radio',
      'checked:bg-radio',
      'checked:border-black',
      'checked:bg-white',
      'checked:hover:border-black',
      'checked:hover:bg-white',
      'focus:border-2',
      'focus:border-black',
      'focus:ring-transparent',
      'focus:ring-offset-0',
      'checked:focus:border-black',
      'checked:focus:bg-white'
    ].join(' ');
  }

  <template>
    <input
      id={{@id}}
      type='radio'
      class={{this.styles}}
      value={{@value}}
      checked={{@isChecked}}
      {{on 'change' this.handleInput}}
      disabled={{@isReadOnly}}
      ...attributes
    />
  </template>
}
